const zurichCommunes = [
  {
    code: '150101',
    name: 'Arica',
  },
  {
    code: '150901',
    name: 'Camarones',
  },
  {
    code: '151001',
    name: 'Putre',
  },
  {
    code: '151301',
    name: 'General Lagos',
  },
  {
    code: '010201',
    name: 'Iquique',
  },
  {
    code: '010202',
    name: 'Alto Hospicio',
  },
  {
    code: '010601',
    name: 'Pozo Almonte',
  },
  {
    code: '011101',
    name: 'Camiña',
  },
  {
    code: '011201',
    name: 'Colchane',
  },
  {
    code: '010301',
    name: 'Huara',
  },
  {
    code: '010501',
    name: 'Pica',
  },
  {
    code: '020101',
    name: 'Antofagasta',
  },
  {
    code: '020401',
    name: 'Mejillones',
  },
  {
    code: '021501',
    name: 'Sierra Gorda',
  },
  {
    code: '020901',
    name: 'Taltal',
  },
  {
    code: '020201',
    name: 'Calama',
  },
  {
    code: '021401',
    name: 'Ollagüe',
  },
  {
    code: '021101',
    name: 'San Pedro de Atacama',
  },
  {
    code: '021001',
    name: 'Tocopilla',
  },
  {
    code: '020701',
    name: 'María Elena',
  },
  {
    code: '030101',
    name: 'Copiapó',
  },
  {
    code: '030201',
    name: 'Caldera',
  },
  {
    code: '031201',
    name: 'Tierra Amarilla',
  },
  {
    code: '030301',
    name: 'Chañaral',
  },
  {
    code: '031601',
    name: 'Diego de Almagro',
  },
  {
    code: '031301',
    name: 'Vallenar',
  },
  {
    code: '031901',
    name: 'Alto del Carmen',
  },
  {
    code: '030501',
    name: 'Freirina',
  },
  {
    code: '031401',
    name: 'Huasco',
  },
  {
    code: '040101',
    name: 'La Serena',
  },
  {
    code: '040401',
    name: 'Coquimbo',
  },
  {
    code: '040201',
    name: 'Andacollo',
  },
  {
    code: '041801',
    name: 'La Higuera',
  },
  {
    code: '042001',
    name: 'Paiguano',
  },
  {
    code: '041201',
    name: 'Vicuña',
  },
  {
    code: '040501',
    name: 'Illapel',
  },
  {
    code: '043001',
    name: 'Canela',
  },
  {
    code: '041301',
    name: 'Los Vilos',
  },
  {
    code: '040901',
    name: 'Salamanca',
  },
  {
    code: '040601',
    name: 'Ovalle',
  },
  {
    code: '040301',
    name: 'Combarbalá',
  },
  {
    code: '042401',
    name: 'Monte Patria',
  },
  {
    code: '040801',
    name: 'Punitaqui',
  },
  {
    code: '042201',
    name: 'Río Hurtado',
  },
  {
    code: '050101',
    name: 'Valparaíso',
  },
  {
    code: '051201',
    name: 'Casablanca',
  },
  {
    code: '050802',
    name: 'Concón',
  },
  {
    code: '056400',
    name: 'Juan Fernández',
  },
  {
    code: '054801',
    name: 'Puchuncaví',
  },
  {
    code: '052101',
    name: 'Quintero',
  },
  {
    code: '050801',
    name: 'Viña del Mar',
  },
  {
    code: '055601',
    name: 'Isla de Pascua',
  },
  {
    code: '050601',
    name: 'Los Andes',
  },
  {
    code: '052901',
    name: 'Calle Larga',
  },
  {
    code: '055701',
    name: 'Rinconada',
  },
  {
    code: '054601',
    name: 'San Esteban',
  },
  {
    code: '051401',
    name: 'La Ligua',
  },
  {
    code: '050901',
    name: 'Cabildo',
  },
  {
    code: '053501',
    name: 'Papudo',
  },
  {
    code: '050401',
    name: 'Petorca',
  },
  {
    code: '052701',
    name: 'Zapallar',
  },
  {
    code: '050301',
    name: 'Quillota',
  },
  {
    code: '051001',
    name: 'Calera',
  },
  {
    code: '055901',
    name: 'Hijuelas',
  },
  {
    code: '054001',
    name: 'La Cruz',
  },
  {
    code: '055001',
    name: 'Nogales',
  },
  {
    code: '050201',
    name: 'San Antonio',
  },
  {
    code: '053801',
    name: 'Algarrobo',
  },
  {
    code: '051301',
    name: 'Cartagena',
  },
  {
    code: '053401',
    name: 'El Quisco',
  },
  {
    code: '053001',
    name: 'El Tabo',
  },
  {
    code: '052801',
    name: 'Santo Domingo',
  },
  {
    code: '050501',
    name: 'San Felipe',
  },
  {
    code: '054501',
    name: 'Catemu',
  },
  {
    code: '051601',
    name: 'Llaillay',
  },
  {
    code: '053101',
    name: 'Panquehue',
  },
  {
    code: '051901',
    name: 'Putaendo',
  },
  {
    code: '055401',
    name: 'Santa María',
  },
  {
    code: '052001',
    name: 'Quilpué',
  },
  {
    code: '051501',
    name: 'Limache',
  },
  {
    code: '053201',
    name: 'Olmué',
  },
  {
    code: '052201',
    name: 'Villa Alemana',
  },
  {
    code: '130125',
    name: 'Santiago',
  },
  {
    code: '130128',
    name: 'Cerrillos',
  },
  {
    code: '130103',
    name: 'Cerro Navia',
  },
  {
    code: '130102',
    name: 'Conchalí',
  },
  {
    code: '130134',
    name: 'El Bosque',
  },
  {
    code: '130104',
    name: 'Estación Central',
  },
  {
    code: '130135',
    name: 'Huechuraba',
  },
  {
    code: '130130',
    name: 'Independencia',
  },
  {
    code: '130106',
    name: 'La Cisterna',
  },
  {
    code: '130107',
    name: 'La Florida',
  },
  {
    code: '130108',
    name: 'La Granja',
  },
  {
    code: '130110',
    name: 'La Pintana',
  },
  {
    code: '130111',
    name: 'La Reina',
  },
  {
    code: '130105',
    name: 'Las Condes',
  },
  {
    code: '130127',
    name: 'Lo Barnechea',
  },
  {
    code: '130133',
    name: 'Lo Espejo',
  },
  {
    code: '130109',
    name: 'Lo Prado',
  },
  {
    code: '130113',
    name: 'Macul',
  },
  {
    code: '130112',
    name: 'Maipú',
  },
  {
    code: '130114',
    name: 'Ñuñoa',
  },
  {
    code: '130126',
    name: 'Pedro Aguirre Cerda',
  },
  {
    code: '130117',
    name: 'Peñalolén',
  },
  {
    code: '130115',
    name: 'Providencia',
  },
  {
    code: '130118',
    name: 'Pudahuel',
  },
  {
    code: '130119',
    name: 'Quilicura',
  },
  {
    code: '130120',
    name: 'Quinta Normal',
  },
  {
    code: '130131',
    name: 'Recoleta',
  },
  {
    code: '130121',
    name: 'Renca',
  },
  {
    code: '130132',
    name: 'San Joaquín',
  },
  {
    code: '130123',
    name: 'San Miguel',
  },
  {
    code: '130124',
    name: 'San Ramón',
  },
  {
    code: '130129',
    name: 'Vitacura',
  },
  {
    code: '130116',
    name: 'Puente Alto',
  },
  {
    code: '132601',
    name: 'Pirque',
  },
  {
    code: '132101',
    name: 'San José de Maipo',
  },
  {
    code: '130201',
    name: 'Colina',
  },
  {
    code: '132501',
    name: 'Lampa',
  },
  {
    code: '131601',
    name: 'Tiltil',
  },
  {
    code: '130122',
    name: 'San Bernardo',
  },
  {
    code: '130301',
    name: 'Buin',
  },
  {
    code: '132401',
    name: 'Calera de Tango',
  },
  {
    code: '130901',
    name: 'Paine',
  },
  {
    code: '130701',
    name: 'Melipilla',
  },
  {
    code: '134101',
    name: 'Alhué',
  },
  {
    code: '130401',
    name: 'Curacaví',
  },
  {
    code: '133401',
    name: 'María Pinto',
  },
  {
    code: '134501',
    name: 'San Pedro',
  },
  {
    code: '131501',
    name: 'Talagante',
  },
  {
    code: '130801',
    name: 'El Monte',
  },
  {
    code: '130501',
    name: 'Isla de Maipo',
  },
  {
    code: '132001',
    name: 'Padre Hurtado',
  },
  {
    code: '131001',
    name: 'Peñaflor',
  },
  {
    code: '060101',
    name: 'Rancagua',
  },
  {
    code: '060901',
    name: 'Codegua',
  },
  {
    code: '061901',
    name: 'Coinco',
  },
  {
    code: '062301',
    name: 'Coltauco',
  },
  {
    code: '060701',
    name: 'Doñihue',
  },
  {
    code: '060601',
    name: 'Graneros',
  },
  {
    code: '061701',
    name: 'Las Cabras',
  },
  {
    code: '060401',
    name: 'Machalí',
  },
  {
    code: '063201',
    name: 'Malloa',
  },
  {
    code: '060501',
    name: 'Mostazal',
  },
  {
    code: '062701',
    name: 'Olivar',
  },
  {
    code: '061601',
    name: 'Peumo',
  },
  {
    code: '063601',
    name: 'Pichidegua',
  },
  {
    code: '063901',
    name: 'Quinta de Tilcoco',
  },
  {
    code: '061101',
    name: 'Rengo',
  },
  {
    code: '060801',
    name: 'Requínoa',
  },
  {
    code: '061301',
    name: 'San Vicente',
  },
  {
    code: '061801',
    name: 'Pichilemu',
  },
  {
    code: '064401',
    name: 'La Estrella',
  },
  {
    code: '062501',
    name: 'Litueche',
  },
  {
    code: '062601',
    name: 'Marchihue',
  },
  {
    code: '064201',
    name: 'Navidad',
  },
  {
    code: '064501',
    name: 'Paredones',
  },
  {
    code: '061001',
    name: 'San Fernando',
  },
  {
    code: '061201',
    name: 'Chépica',
  },
  {
    code: '061401',
    name: 'Chimbarongo',
  },
  {
    code: '063701',
    name: 'Lolol',
  },
  {
    code: '065201',
    name: 'Nancagua',
  },
  {
    code: '064101',
    name: 'Palmilla',
  },
  {
    code: '062101',
    name: 'Peralillo',
  },
  {
    code: '063101',
    name: 'Placilla',
  },
  {
    code: '064901',
    name: 'Pumanque',
  },
  {
    code: '061501',
    name: 'Santa Cruz',
  },
  {
    code: '070101',
    name: 'Talca',
  },
  {
    code: '070301',
    name: 'Constitución',
  },
  {
    code: '071501',
    name: 'Curepto',
  },
  {
    code: '072101',
    name: 'Empedrado',
  },
  {
    code: '073801',
    name: 'Maule',
  },
  {
    code: '073901',
    name: 'Pelarco',
  },
  {
    code: '072201',
    name: 'Pencahue',
  },
  {
    code: '074101',
    name: 'Río Claro',
  },
  {
    code: '074201',
    name: 'San Clemente',
  },
  {
    code: '075001',
    name: 'San Rafael',
  },
  {
    code: '070201',
    name: 'Cauquenes',
  },
  {
    code: '074701',
    name: 'Chanco',
  },
  {
    code: '073501',
    name: 'Pelluhue',
  },
  {
    code: '070401',
    name: 'Curicó',
  },
  {
    code: '073001',
    name: 'Hualañé',
  },
  {
    code: '072001',
    name: 'Licantén',
  },
  {
    code: '070801',
    name: 'Molina',
  },
  {
    code: '071901',
    name: 'Rauco',
  },
  {
    code: '071801',
    name: 'Romeral',
  },
  {
    code: '072601',
    name: 'Sagrada Familia',
  },
  {
    code: '071201',
    name: 'Teno',
  },
  {
    code: '071600',
    name: 'Vichuquén',
  },
  {
    code: '070501',
    name: 'Linares',
  },
  {
    code: '073701',
    name: 'Colbún',
  },
  {
    code: '070601',
    name: 'Longaví',
  },
  {
    code: '071001',
    name: 'Parral',
  },
  {
    code: '074501',
    name: 'Retiro',
  },
  {
    code: '071701',
    name: 'San Javier',
  },
  {
    code: '071301',
    name: 'Villa Alegre',
  },
  {
    code: '074801',
    name: 'Yerbas Buenas',
  },
  {
    code: '081001',
    name: 'Chillán',
  },
  {
    code: '080401',
    name: 'Bulnes',
  },
  {
    code: '081002',
    name: 'Chillán Viejo',
  },
  {
    code: '084901',
    name: 'El Carmen',
  },
  {
    code: '083801',
    name: 'Pemuco',
  },
  {
    code: '085601',
    name: 'Pinto',
  },
  {
    code: '083501',
    name: 'Quillón',
  },
  {
    code: '085201',
    name: 'San Ignacio',
  },
  {
    code: '082401',
    name: 'Yungay',
  },
  {
    code: '087401',
    name: 'Quirihue',
  },
  {
    code: '085001',
    name: 'Cobquecura',
  },
  {
    code: '080601',
    name: 'Coelemu',
  },
  {
    code: '086701',
    name: 'Ninhue',
  },
  {
    code: '086001',
    name: 'Portezuelo',
  },
  {
    code: '084501',
    name: 'Ranquil',
  },
  {
    code: '084201',
    name: 'Treguaco',
  },
  {
    code: '081801',
    name: 'San Carlos',
  },
  {
    code: '083401',
    name: 'Coihueco',
  },
  {
    code: '087601',
    name: 'Ñiquén',
  },
  {
    code: '084301',
    name: 'San Fabián',
  },
  {
    code: '085701',
    name: 'San Nicolás',
  },
  {
    code: '080101',
    name: 'Concepción',
  },
  {
    code: '080701',
    name: 'Coronel',
  },
  {
    code: '080103',
    name: 'Chiguayante',
  },
  {
    code: '085101',
    name: 'Florida',
  },
  {
    code: '082901',
    name: 'Hualqui',
  },
  {
    code: '081601',
    name: 'Lota',
  },
  {
    code: '081701',
    name: 'Penco',
  },
  {
    code: '080102',
    name: 'San Pedro de la Paz',
  },
  {
    code: '087301',
    name: 'Santa Juana',
  },
  {
    code: '082201',
    name: 'Talcahuano',
  },
  {
    code: '082301',
    name: 'Tomé',
  },
  {
    code: '080901',
    name: 'Hualpén',
  },
  {
    code: '081201',
    name: 'Lebu',
  },
  {
    code: '080301',
    name: 'Arauco',
  },
  {
    code: '080501',
    name: 'Cañete',
  },
  {
    code: '081901',
    name: 'Contulmo',
  },
  {
    code: '080801',
    name: 'Curanilahue',
  },
  {
    code: '082601',
    name: 'Los Alamos',
  },
  {
    code: '086801',
    name: 'Tirúa',
  },
  {
    code: '080201',
    name: 'Los Angeles',
  },
  {
    code: '084701',
    name: 'Antuco',
  },
  {
    code: '082801',
    name: 'Cabrero',
  },
  {
    code: '081101',
    name: 'Laja',
  },
  {
    code: '081501',
    name: 'Mulchén',
  },
  {
    code: '081401',
    name: 'Nacimiento',
  },
  {
    code: '083301',
    name: 'Negrete',
  },
  {
    code: '086101',
    name: 'Quilaco',
  },
  {
    code: '085501',
    name: 'Quilleco',
  },
  {
    code: '082001',
    name: 'San Rosendo',
  },
  {
    code: '085901',
    name: 'Santa Bárbara',
  },
  {
    code: '086301',
    name: 'Tucapel',
  },
  {
    code: '082501',
    name: 'Yumbel',
  },
  {
    code: '087000',
    name: 'Alto Biobío',
  },
  {
    code: '090101',
    name: 'Temuco',
  },
  {
    code: '090501',
    name: 'Carahue',
  },
  {
    code: '090601',
    name: 'Cunco',
  },
  {
    code: '095801',
    name: 'Curarrehue',
  },
  {
    code: '092701',
    name: 'Freire',
  },
  {
    code: '094101',
    name: 'Galvarino',
  },
  {
    code: '090901',
    name: 'Gorbea',
  },
  {
    code: '091001',
    name: 'Lautaro',
  },
  {
    code: '091101',
    name: 'Loncoche',
  },
  {
    code: '094801',
    name: 'Melipeuco',
  },
  {
    code: '091201',
    name: 'Nueva Imperial',
  },
  {
    code: '090102',
    name: 'Padre Las Casas',
  },
  {
    code: '092501',
    name: 'Perquenco',
  },
  {
    code: '091301',
    name: 'Pitrufquén',
  },
  {
    code: '091401',
    name: 'Pucón',
  },
  {
    code: '091601',
    name: 'Saavedra',
  },
  {
    code: '095101',
    name: 'Teodoro Schmidt',
  },
  {
    code: '093901',
    name: 'Toltén',
  },
  {
    code: '092801',
    name: 'Vilcún',
  },
  {
    code: '092001',
    name: 'Villarrica',
  },
  {
    code: '094601',
    name: 'Cholchol',
  },
  {
    code: '090201',
    name: 'Angol',
  },
  {
    code: '090401',
    name: 'Collipulli',
  },
  {
    code: '092601',
    name: 'Curacautín',
  },
  {
    code: '092401',
    name: 'Ercilla',
  },
  {
    code: '090701',
    name: 'Lonquimay',
  },
  {
    code: '093701',
    name: 'Los Sauces',
  },
  {
    code: '093801',
    name: 'Lumaco',
  },
  {
    code: '091501',
    name: 'Purén',
  },
  {
    code: '091701',
    name: 'Renaico',
  },
  {
    code: '091801',
    name: 'Traiguén',
  },
  {
    code: '091901',
    name: 'Victoria',
  },
  {
    code: '141601',
    name: 'Valdivia',
  },
  {
    code: '140501',
    name: 'Corral',
  },
  {
    code: '140701',
    name: 'Lanco',
  },
  {
    code: '140601',
    name: 'Los Lagos',
  },
  {
    code: '143501',
    name: 'Máfil',
  },
  {
    code: '145901',
    name: 'Mariquina',
  },
  {
    code: '141701',
    name: 'Paillaco',
  },
  {
    code: '141001',
    name: 'Panguipulli',
  },
  {
    code: '141501',
    name: 'La Unión',
  },
  {
    code: '143301',
    name: 'Futrono',
  },
  {
    code: '142901',
    name: 'Lago Ranco',
  },
  {
    code: '141301',
    name: 'Río Bueno',
  },
  {
    code: '100101',
    name: 'Puerto Montt',
  },
  {
    code: '100301',
    name: 'Calbuco',
  },
  {
    code: '106201',
    name: 'Cochamó',
  },
  {
    code: '102201',
    name: 'Fresia',
  },
  {
    code: '102101',
    name: 'Frutillar',
  },
  {
    code: '105201',
    name: 'Los Muermos',
  },
  {
    code: '100801',
    name: 'Llanquihue',
  },
  {
    code: '102301',
    name: 'Maullín',
  },
  {
    code: '101101',
    name: 'Puerto Varas',
  },
  {
    code: '100401',
    name: 'Castro',
  },
  {
    code: '100201',
    name: 'Ancud',
  },
  {
    code: '101801',
    name: 'Chonchi',
  },
  {
    code: '107101',
    name: 'Curaco de Vélez',
  },
  {
    code: '106901',
    name: 'Dalcahue',
  },
  {
    code: '107101',
    name: 'Puqueldón',
  },
  {
    code: '102001',
    name: 'Queilén',
  },
  {
    code: '101901',
    name: 'Quellón',
  },
  {
    code: '107001',
    name: 'Quemchi',
  },
  {
    code: '107301',
    name: 'Quinchao',
  },
  {
    code: '100901',
    name: 'Osorno',
  },
  {
    code: '103701',
    name: 'Puerto Octay',
  },
  {
    code: '101201',
    name: 'Purranque',
  },
  {
    code: '105001',
    name: 'Puyehue',
  },
  {
    code: '101401',
    name: 'Río Negro',
  },
  {
    code: '103801',
    name: 'San Juan de la Costa',
  },
  {
    code: '105501',
    name: 'San Pablo',
  },
  {
    code: '105401',
    name: 'Chaitén',
  },
  {
    code: '104001',
    name: 'Futaleufú',
  },
  {
    code: '106801',
    name: 'Hualaihué',
  },
  {
    code: '107401',
    name: 'Palena',
  },
  {
    code: '110101',
    name: 'Coihaique',
  },
  {
    code: '111201',
    name: 'Lago Verde',
  },
  {
    code: '110501',
    name: 'Aisén',
  },
  {
    code: '110601',
    name: 'Cisnes',
  },
  {
    code: '111701',
    name: 'Guaitecas',
  },
  {
    code: '110301',
    name: 'Cochrane',
  },
  {
    code: '111101',
    name: "O'Higgins",
  },
  {
    code: '111601',
    name: 'Tortel',
  },
  {
    code: '110401',
    name: 'Chile Chico',
  },
  {
    code: '110901',
    name: 'Río Ibáñez',
  },
  {
    code: '120101',
    name: 'Punta Arenas',
  },
  {
    code: '121401',
    name: 'Laguna Blanca',
  },
  {
    code: '120801',
    name: 'Río Verde',
  },
  {
    code: '120901',
    name: 'San Gregorio',
  },
  {
    code: '121601',
    name: 'Cabo de Hornos',
  },
  {
    code: '120301',
    name: 'Porvenir',
  },
  {
    code: '121001',
    name: 'Primavera',
  },
  {
    code: '121201',
    name: 'Timaukel',
  },
  {
    code: '120401',
    name: 'Natales',
  },
  {
    code: '120701',
    name: 'Torres del Paine',
  },
  {
    code: '052702',
    name: 'CATAPILCO',
  },
  {
    code: '082701',
    name: 'DICHATO',
  },
  {
    code: '071601',
    name: 'Vichuquén',
  },
  {
    code: '94401',
    name: 'Coñaripe',
  },
  {
    code: '054101',
    name: 'Maitencillo',
  },
];

const hdiCommunes = [
  { name: 'CAMINA', code: '1CC' },
  { name: 'COLCHANE', code: '2CC' },
  { name: 'HUARA', code: '3CC' },
  { name: 'IQUIQUE', code: '4CC' },
  { name: 'PICA', code: '5CC' },
  { name: 'POZO ALMONTE', code: '6CC' },
  { name: 'ANTOFAGASTA', code: '7CC' },
  { name: 'CALAMA', code: '8CC' },
  { name: 'MARIA ELENA', code: '9CC' },
  { name: 'MEJILLONES', code: '10CC' },
  { name: 'OLLAGUE', code: '11CC' },
  { name: 'SAN PEDRO DE ATACAMA', code: '12CC' },
  { name: 'SIERRA GORDA', code: '13CC' },
  { name: 'TALTAL', code: '14CC' },
  { name: 'TOCOPILLA', code: '15CC' },
  { name: 'ALTO DEL CARMEN', code: '16CC' },
  { name: 'CALDERA', code: '17CC' },
  { name: 'CHANARAL', code: '18CC' },
  { name: 'COPIAPO', code: '19CC' },
  { name: 'DIEGO DE ALMAGRO', code: '20CC' },
  { name: 'FREIRINA', code: '21CC' },
  { name: 'HUASCO', code: '22CC' },
  { name: 'TIERRA AMARILLA', code: '23CC' },
  { name: 'VALLENAR', code: '24CC' },
  { name: 'ANDACOLLO', code: '25CC' },
  { name: 'CANELA', code: '26CC' },
  { name: 'COMBARBALA', code: '27CC' },
  { name: 'COQUIMBO', code: '28CC' },
  { name: 'ILLAPEL', code: '29CC' },
  { name: 'LA HIGUERA', code: '30CC' },
  { name: 'LA SERENA', code: '31CC' },
  { name: 'LOS VILOS', code: '32CC' },
  { name: 'MONTE PATRIA', code: '33CC' },
  { name: 'OVALLE', code: '34CC' },
  { name: 'PAIHUANO', code: '35CC' },
  { name: 'PUNITAQUI', code: '36CC' },
  { name: 'RIO HURTADO', code: '37CC' },
  { name: 'SALAMANCA', code: '38CC' },
  { name: 'VICUNA', code: '39CC' },
  { name: 'ALGARROBO', code: '40CC' },
  { name: 'CABILDO', code: '41CC' },
  { name: 'CALLE LARGA', code: '42CC' },
  { name: 'CARTAGENA', code: '43CC' },
  { name: 'CASABLANCA', code: '44CC' },
  { name: 'CATEMU', code: '45CC' },
  { name: 'CONCON', code: '46CC' },
  { name: 'EL QUISCO', code: '47CC' },
  { name: 'EL TABO', code: '48CC' },
  { name: 'HIJUELAS', code: '49CC' },
  { name: 'ISLA DE PASCUA', code: '50CC' },
  { name: 'JUAN FERNANDEZ', code: '51CC' },
  { name: 'LA CALERA', code: '52CC' },
  { name: 'LA CRUZ', code: '53CC' },
  { name: 'LA LIGUA', code: '54CC' },
  { name: 'LIMACHE', code: '55CC' },
  { name: 'LLAY-LLAY', code: '56CC' },
  { name: 'LOS ANDES', code: '57CC' },
  { name: 'NOGALES', code: '58CC' },
  { name: 'OLMUE', code: '59CC' },
  { name: 'PANQUEHUE', code: '60CC' },
  { name: 'PAPUDO', code: '61CC' },
  { name: 'PETORCA', code: '62CC' },
  { name: 'PUCHUNCAVI', code: '63CC' },
  { name: 'PUTAENDO', code: '64CC' },
  { name: 'QUILLOTA', code: '65CC' },
  { name: 'QUILPUE', code: '66CC' },
  { name: 'QUINTERO', code: '67CC' },
  { name: 'RINCONADA', code: '68CC' },
  { name: 'SAN ANTONIO', code: '69CC' },
  { name: 'SAN ESTEBAN', code: '70CC' },
  { name: 'SAN FELIPE', code: '71CC' },
  { name: 'SANTA MARIA', code: '72CC' },
  { name: 'SANTO DOMINGO', code: '73CC' },
  { name: 'VALPARAISO', code: '74CC' },
  { name: 'VILLA ALEMANA', code: '75CC' },
  { name: 'VINA DEL MAR', code: '76CC' },
  { name: 'ZAPALLAR', code: '77CC' },
  { name: 'CHEPICA', code: '78CC' },
  { name: 'CHIMBARONGO', code: '79CC' },
  { name: 'CODEGUA', code: '80CC' },
  { name: 'COINCO', code: '81CC' },
  { name: 'COLTAUCO', code: '82CC' },
  { name: 'DONIHUE', code: '83CC' },
  { name: 'GRANEROS', code: '84CC' },
  { name: 'LA ESTRELLA', code: '85CC' },
  { name: 'LAS CABRAS', code: '86CC' },
  { name: 'LITUECHE', code: '87CC' },
  { name: 'LOLOL', code: '88CC' },
  { name: 'MACHALI', code: '89CC' },
  { name: 'MALLOA', code: '90CC' },
  { name: 'MARCHIGUE', code: '91CC' },
  { name: 'MOSTAZAL', code: '92CC' },
  { name: 'NANCAGUA', code: '93CC' },
  { name: 'NAVIDAD', code: '94CC' },
  { name: 'OLIVAR', code: '95CC' },
  { name: 'PALMILLA', code: '96CC' },
  { name: 'PAREDONES', code: '97CC' },
  { name: 'PERALILLO', code: '98CC' },
  { name: 'PEUMO', code: '99CC' },
  { name: 'PICHIDEGUA', code: '100CC' },
  { name: 'PICHILEMU', code: '101CC' },
  { name: 'PLACILLA', code: '102CC' },
  { name: 'PUMANQUE', code: '103CC' },
  { name: 'QUINTA DE TILCOCO', code: '104CC' },
  { name: 'RANCAGUA', code: '105CC' },
  { name: 'RENGO', code: '106CC' },
  { name: 'REQUINOA', code: '107CC' },
  { name: 'SAN FERNANDO', code: '108CC' },
  { name: 'SANTA CRUZ', code: '109CC' },
  { name: 'SN VICENTE DE TAGUA TAGUA', code: '110CC' },
  { name: 'CAUQUENES', code: '111CC' },
  { name: 'CHANCO', code: '112CC' },
  { name: 'COLBUN', code: '113CC' },
  { name: 'CONSTITUCION', code: '114CC' },
  { name: 'CUREPTO', code: '115CC' },
  { name: 'CURICO', code: '116CC' },
  { name: 'EMPEDRADO', code: '117CC' },
  { name: 'HUALANE', code: '118CC' },
  { name: 'LICANTEN', code: '119CC' },
  { name: 'LINARES', code: '120CC' },
  { name: 'LONGAVI', code: '121CC' },
  { name: 'MAULE', code: '122CC' },
  { name: 'MOLINA', code: '123CC' },
  { name: 'PARRAL', code: '124CC' },
  { name: 'PELARCO', code: '125CC' },
  { name: 'PELLUHUE', code: '126CC' },
  { name: 'PENCAHUE', code: '127CC' },
  { name: 'RAUCO', code: '128CC' },
  { name: 'RETIRO', code: '129CC' },
  { name: 'RIO CLARO', code: '130CC' },
  { name: 'ROMERAL', code: '131CC' },
  { name: 'SAGRADA FAMILIA', code: '132CC' },
  { name: 'SAN CLEMENTE', code: '133CC' },
  { name: 'SAN JAVIER', code: '134CC' },
  { name: 'SAN RAFAEL', code: '135CC' },
  { name: 'TALCA', code: '136CC' },
  { name: 'TENO', code: '137CC' },
  { name: 'VICHUQUEN', code: '138CC' },
  { name: 'VILLA ALEGRE', code: '139CC' },
  { name: 'YERBAS BUENAS', code: '140CC' },
  { name: 'HUALAÑE', code: '141CC' },
  { name: 'ANTUCO', code: '142CC' },
  { name: 'ARAUCO', code: '143CC' },
  { name: 'BULNES', code: '144CC' },
  { name: 'CABRERO', code: '145CC' },
  { name: 'CANETE', code: '146CC' },
  { name: 'CHIGUAYANTE', code: '147CC' },
  { name: 'CHILLAN', code: '148CC' },
  { name: 'CHILLAN VIEJO', code: '149CC' },
  { name: 'COBQUECURA', code: '150CC' },
  { name: 'COELEMU', code: '151CC' },
  { name: 'COIHUECO', code: '152CC' },
  { name: 'CONCEPCION', code: '153CC' },
  { name: 'CONTULMO', code: '154CC' },
  { name: 'CORONEL', code: '155CC' },
  { name: 'CURANILAHUE', code: '156CC' },
  { name: 'EL CARMEN', code: '157CC' },
  { name: 'FLORIDA', code: '158CC' },
  { name: 'HUALQUI', code: '159CC' },
  { name: 'LAJA', code: '160CC' },
  { name: 'LEBU', code: '161CC' },
  { name: 'LOS ALAMOS', code: '162CC' },
  { name: 'LOS ANGELES', code: '163CC' },
  { name: 'LOTA', code: '164CC' },
  { name: 'MULCHEN', code: '165CC' },
  { name: 'NACIMIENTO', code: '166CC' },
  { name: 'NEGRETE', code: '167CC' },
  { name: 'NINHUE', code: '168CC' },
  { name: 'NIQUEN', code: '169CC' },
  { name: 'PEMUCO', code: '170CC' },
  { name: 'PENCO', code: '171CC' },
  { name: 'PINTO', code: '172CC' },
  { name: 'PORTEZUELO', code: '173CC' },
  { name: 'QUILACO', code: '174CC' },
  { name: 'QUILLECO', code: '175CC' },
  { name: 'QUILLON', code: '176CC' },
  { name: 'QUIRIHUE', code: '177CC' },
  { name: 'RANQUIL', code: '178CC' },
  { name: 'SAN CARLOS', code: '179CC' },
  { name: 'SAN FABIAN', code: '180CC' },
  { name: 'SAN IGNACIO', code: '181CC' },
  { name: 'SAN NICOLAS', code: '182CC' },
  { name: 'SAN PEDRO DE LA PAZ', code: '183CC' },
  { name: 'SAN ROSENDO', code: '184CC' },
  { name: 'SANTA BARBARA', code: '185CC' },
  { name: 'SANTA JUANA', code: '186CC' },
  { name: 'TALCAHUANO', code: '187CC' },
  { name: 'TIRUA', code: '188CC' },
  { name: 'TOME', code: '189CC' },
  { name: 'TREHUACO', code: '190CC' },
  { name: 'TUCAPEL', code: '191CC' },
  { name: 'YUMBEL', code: '192CC' },
  { name: 'YUNGAY', code: '193CC' },
  { name: 'HUALPEN', code: '194CC' },
  { name: 'ANGOL', code: '195CC' },
  { name: 'CARAHUE', code: '196CC' },
  { name: 'COLLIPULLI', code: '197CC' },
  { name: 'CUNCO', code: '198CC' },
  { name: 'CURACAUTIN', code: '199CC' },
  { name: 'CURARREHUE', code: '200CC' },
  { name: 'ERCILLA', code: '201CC' },
  { name: 'FREIRE', code: '202CC' },
  { name: 'GALVARINO', code: '203CC' },
  { name: 'GORBEA', code: '204CC' },
  { name: 'LAUTARO', code: '205CC' },
  { name: 'LONCOCHE', code: '206CC' },
  { name: 'LONQUIMAY', code: '207CC' },
  { name: 'LOS SAUCES', code: '208CC' },
  { name: 'LUMACO', code: '209CC' },
  { name: 'MELIPEUCO', code: '210CC' },
  { name: 'NUEVA IMPERIAL', code: '211CC' },
  { name: 'PADRE LAS CASAS', code: '212CC' },
  { name: 'PERQUENCO', code: '213CC' },
  { name: 'PITRUFQUEN', code: '214CC' },
  { name: 'PUCON', code: '215CC' },
  { name: 'PUREN', code: '216CC' },
  { name: 'RENAICO', code: '217CC' },
  { name: 'SAAVEDRA', code: '218CC' },
  { name: 'TEMUCO', code: '219CC' },
  { name: 'TEODORO SCHMIDT', code: '220CC' },
  { name: 'TOLTEN', code: '221CC' },
  { name: 'TRAIGUEN', code: '222CC' },
  { name: 'VICTORIA', code: '223CC' },
  { name: 'VILCUN', code: '224CC' },
  { name: 'VILLARRICA', code: '225CC' },
  { name: 'ANCUD', code: '226CC' },
  { name: 'CALBUCO', code: '227CC' },
  { name: 'CASTRO', code: '228CC' },
  { name: 'CHAITEN', code: '229CC' },
  { name: 'CHONCHI', code: '230CC' },
  { name: 'COCHAMO', code: '231CC' },
  { name: 'CURACO DE VELEZ', code: '232CC' },
  { name: 'DALCAHUE', code: '233CC' },
  { name: 'FRESIA', code: '234CC' },
  { name: 'FRUTILLAR', code: '235CC' },
  { name: 'FUTALEUFU', code: '236CC' },
  { name: 'HUALAIHUE', code: '237CC' },
  { name: 'LLANQUIHUE', code: '238CC' },
  { name: 'LOS MUERMOS', code: '239CC' },
  { name: 'MAULLIN', code: '240CC' },
  { name: 'OSORNO', code: '241CC' },
  { name: 'PALENA', code: '242CC' },
  { name: 'PUERTO MONTT', code: '243CC' },
  { name: 'PUERTO OCTAY', code: '244CC' },
  { name: 'PUERTO VARAS', code: '245CC' },
  { name: 'PUQUELDON', code: '246CC' },
  { name: 'PURRANQUE', code: '247CC' },
  { name: 'PUYEHUE', code: '248CC' },
  { name: 'QUEILEN', code: '249CC' },
  { name: 'QUELLON', code: '250CC' },
  { name: 'QUEMCHI', code: '251CC' },
  { name: 'QUINCHAO', code: '252CC' },
  { name: 'RIO NEGRO', code: '253CC' },
  { name: 'SAN JUAN DE LA COSTA', code: '254CC' },
  { name: 'SAN PABLO', code: '255CC' },
  { name: 'AISEN', code: '256CC' },
  { name: 'CHILE CHICO', code: '257CC' },
  { name: 'CISNES', code: '258CC' },
  { name: 'COCHRANE', code: '259CC' },
  { name: 'COYHAIQUE', code: '260CC' },
  { name: 'GUAITECAS', code: '261CC' },
  { name: 'LAGO VERDE', code: '262CC' },
  // eslint-disable-next-line quotes
  { name: "O'HIGGINS", code: '263CC' },
  { name: 'RIO IBANEZ', code: '264CC' },
  { name: 'TORTEL', code: '265CC' },
  { name: 'AYSEN', code: '266CC' },
  { name: 'ANTARTICA', code: '267CC' },
  { name: 'LAGUNA BLANCA', code: '268CC' },
  { name: 'NATALES', code: '269CC' },
  { name: 'NAVARINO', code: '270CC' },
  { name: 'PORVENIR', code: '271CC' },
  { name: 'PRIMAVERA', code: '272CC' },
  { name: 'PUNTA ARENAS', code: '273CC' },
  { name: 'RIO VERDE', code: '274CC' },
  { name: 'SAN GREGORIO', code: '275CC' },
  { name: 'TIMAUKEL', code: '276CC' },
  { name: 'TORRES DEL PAINE', code: '277CC' },
  { name: 'CABO DE HORNOS', code: '278CC' },
  { name: 'ALHUE.', code: '279CC' },
  { name: 'BUIN', code: '280CC' },
  { name: 'SAN VICENTE', code: '281CC' },
  { name: 'CALERA DE TANGO', code: '282CC' },
  { name: 'CERRILLOS', code: '283CC' },
  { name: 'ALTO BIOBÍO', code: '284CC' },
  { name: 'ALTO HOSPICIO', code: '285CC' },
  { name: 'CERRO NAVIA', code: '286CC' },
  { name: 'COLINA', code: '287CC' },
  { name: 'CONCHALI', code: '288CC' },
  { name: 'CURACAVI', code: '289CC' },
  { name: 'EL BOSQUE', code: '290CC' },
  { name: 'EL MONTE', code: '291CC' },
  { name: 'ESTACION CENTRAL', code: '292CC' },
  { name: 'HUECHURABA', code: '293CC' },
  { name: 'INDEPENDENCIA', code: '294CC' },
  { name: 'ISLA DE MAIPO', code: '295CC' },
  { name: 'LA CISTERNA', code: '296CC' },
  { name: 'LA FLORIDA', code: '297CC' },
  { name: 'LA GRANJA', code: '298CC' },
  { name: 'LA PINTANA', code: '299CC' },
  { name: 'LA REINA', code: '300CC' },
  { name: 'LAMPA', code: '301CC' },
  { name: 'LAS CONDES', code: '302CC' },
  { name: 'LO BARNECHEA', code: '303CC' },
  { name: 'LO ESPEJO', code: '304CC' },
  { name: 'LO PRADO', code: '305CC' },
  { name: 'MACUL', code: '306CC' },
  { name: 'MAIPU', code: '307CC' },
  { name: 'MARIA PINTO', code: '308CC' },
  { name: 'MELIPILLA', code: '309CC' },
  { name: 'NUNOA', code: '310CC' },
  { name: 'PADRE HURTADO', code: '311CC' },
  { name: 'PAINE', code: '312CC' },
  { name: 'PEDRO AGUIRRE CERDA', code: '313CC' },
  { name: 'PENALOLEN', code: '314CC' },
  { name: 'PEÑAFLOR', code: '315CC' },
  { name: 'PIRQUE', code: '316CC' },
  { name: 'PROVIDENCIA', code: '317CC' },
  { name: 'PUDAHUEL', code: '318CC' },
  { name: 'PUENTE ALTO', code: '319CC' },
  { name: 'QUILICURA', code: '320CC' },
  { name: 'QUINTA NORMAL', code: '321CC' },
  { name: 'RECOLETA', code: '322CC' },
  { name: 'RENCA', code: '323CC' },
  { name: 'SAN BERNARDO', code: '324CC' },
  { name: 'SAN JOAQUIN', code: '325CC' },
  { name: 'SAN JOSE DE MAIPO', code: '326CC' },
  { name: 'SAN MIGUEL', code: '327CC' },
  { name: 'SAN PEDRO', code: '328CC' },
  { name: 'SAN RAMON', code: '329CC' },
  { name: 'SANTIAGO', code: '330CC' },
  { name: 'TALAGANTE', code: '331CC' },
  { name: 'TILTIL', code: '332CC' },
  { name: 'VITACURA', code: '333CC' },
  { name: 'CORRAL', code: '334CC' },
  { name: 'FUTRONO', code: '335CC' },
  { name: 'LA UNION', code: '336CC' },
  { name: 'LAGO RANCO', code: '337CC' },
  { name: 'LANCO', code: '338CC' },
  { name: 'LOS LAGOS', code: '339CC' },
  { name: 'MAFIL', code: '340CC' },
  { name: 'PAILLACO', code: '341CC' },
  { name: 'PANGUIPULLI', code: '342CC' },
  { name: 'RIO BUENO', code: '343CC' },
  { name: 'CHOLCHOL', code: '344CC' },
  { name: 'SAN JOSE DE LA MARIQUINA', code: '345CC' },
  { name: 'VALDIVIA', code: '346CC' },
  { name: 'MARIQUINA', code: '347CC' },
  { name: 'ARICA', code: '348CC' },
  { name: 'CAMARONES', code: '349CC' },
  { name: 'GENERAL LAGOS', code: '350CC' },
  { name: 'PUTRE', code: '351CC' },
];

const bciCommunes = [
  { name: 'ALGARROBO', code: 44 },
  { name: 'ALHUE', code: 109 },
  { name: 'ALTO BIOBIO', code: 346 },
  { name: 'ALTO DEL CARMEN', code: 302 },
  { name: 'ALTO HOSPICIO', code: 344 },
  { name: 'ANCUD', code: 277 },
  { name: 'ANDACOLLO', code: 22 },
  { name: 'ANGOL', code: 216 },
  { name: 'ANTARTICA', code: 347 },
  { name: 'ANTOFAGASTA', code: 7 },
  { name: 'ANTUCO', code: 303 },
  { name: 'ARAUCO', code: 198 },
  { name: 'ARICA', code: 1 },
  { name: 'AYSEN', code: 285 },
  { name: 'BUIN', code: 103 },
  { name: 'BULNES', code: 180 },
  { name: 'CABILDO', code: 56 },
  { name: 'CABO DE HORNOS', code: 319 },
  { name: 'CABRERO', code: 208 },
  { name: 'CALAMA', code: 10 },
  { name: 'CALBUCO', code: 265 },
  { name: 'CALDERA', code: 14 },
  { name: 'CALERA DE TANGO', code: 99 },
  { name: 'CALLE LARGA', code: 67 },
  { name: 'CAMARONES', code: 295 },
  { name: 'CAMINA', code: 296 },
  { name: 'CANELA', code: 31 },
  { name: 'CAÑETE', code: 201 },
  { name: 'CARAHUE', code: 235 },
  { name: 'CARTAGENA', code: 46 },
  { name: 'CASABLANCA', code: 40 },
  { name: 'CASTRO', code: 270 },
  { name: 'CATEMU', code: 63 },
  { name: 'CAUQUENES', code: 166 },
  { name: 'CERRILLOS', code: 333 },
  { name: 'CERRO NAVIA', code: 324 },
  { name: 'CHAITEN', code: 280 },
  { name: 'CHAÑARAL', code: 11 },
  { name: 'CHANCO', code: 167 },
  { name: 'CHEPICA', code: 132 },
  { name: 'CHIGUAYANTE', code: 348 },
  { name: 'CHILE CHICO', code: 287 },
  { name: 'CHILLAN', code: 168 },
  { name: 'CHIMBARONGO', code: 125 },
  { name: 'CHOLCHOL', code: 345 },
  { name: 'CHONCHI', code: 271 },
  { name: 'CISNES', code: 286 },
  { name: 'COBQUECURA', code: 175 },
  { name: 'COCHAMO', code: 262 },
  { name: 'COCHRANE', code: 289 },
  { name: 'CODEGUA', code: 110 },
  { name: 'COELEMU', code: 186 },
  { name: 'COIHUECO', code: 170 },
  { name: 'COINCO', code: 114 },
  { name: 'COLBUN', code: 161 },
  { name: 'COLCHANE', code: 297 },
  { name: 'COLINA', code: 76 },
  { name: 'COLLIPULLI', code: 220 },
  { name: 'COLTAUCO', code: 113 },
  { name: 'COMBARBALA', code: 29 },
  { name: 'CONCEPCION', code: 188 },
  { name: 'CONCHALI', code: 75 },
  { name: 'CONCON', code: 340 },
  { name: 'CONSTITUCION', code: 157 },
  { name: 'CONTULMO', code: 202 },
  { name: 'COPIAPO', code: 13 },
  { name: 'COQUIMBO', code: 21 },
  { name: 'CORONEL', code: 194 },
  { name: 'CORRAL', code: 244 },
  { name: 'COYHAIQUE', code: 284 },
  { name: 'CUNCO', code: 230 },
  { name: 'CURACAUTIN', code: 225 },
  { name: 'CURACAVI', code: 83 },
  { name: 'CURACO DE VELEZ', code: 276 },
  { name: 'CURANILAHUE', code: 197 },
  { name: 'CURARREHUE', code: 305 },
  { name: 'CUREPTO', code: 155 },
  { name: 'CURICO', code: 140 },
  { name: 'DALCAHUE', code: 279 },
  { name: 'DICHATO', code: 353 },
  { name: 'DIEGO DE ALMAGRO', code: 12 },
  { name: 'DOÑIHUE', code: 112 },
  { name: 'EL BOSQUE', code: 338 },
  { name: 'EL CARMEN', code: 185 },
  { name: 'EL MONTE', code: 89 },
  { name: 'EL QUISCO', code: 45 },
  { name: 'EL TABO', code: 47 },
  { name: 'EMPEDRADO', code: 158 },
  { name: 'ERCILLA', code: 221 },
  { name: 'ESTACION CENTRAL', code: 328 },
  { name: 'FLORIDA', code: 193 },
  { name: 'FREIRE', code: 229 },
  { name: 'FREIRINA', code: 17 },
  { name: 'FRESIA', code: 268 },
  { name: 'FRUTILLAR', code: 269 },
  { name: 'FUTALEUFU', code: 281 },
  { name: 'FUTRONO', code: 248 },
  { name: 'GALVARINO', code: 232 },
  { name: 'GENERAL LAGOS', code: 293 },
  { name: 'GORBEA', code: 238 },
  { name: 'GRANEROS', code: 107 },
  { name: 'GUAITECAS', code: 309 },
  { name: 'HIJUELAS', code: 51 },
  { name: 'HUALAIHUE', code: 308 },
  { name: 'HUALAÑE', code: 144 },
  { name: 'HUALPEN', code: 350 },
  { name: 'HUALQUI', code: 192 },
  { name: 'HUARA', code: 3 },
  { name: 'HUASCO', code: 18 },
  { name: 'HUECHURABA', code: 334 },
  { name: 'ILLAPEL', code: 30 },
  { name: 'INDEPENDENCIA', code: 330 },
  { name: 'IQUIQUE', code: 2 },
  { name: 'ISLA DE MAIPO', code: 87 },
  { name: 'ISLA DE PASCUA', code: 41 },
  { name: 'JUAN FERNANDEZ', code: 321 },
  { name: 'LA CALERA', code: 50 },
  { name: 'LA CISTERNA', code: 96 },
  { name: 'LA CRUZ', code: 49 },
  { name: 'LA ESTRELLA', code: 139 },
  { name: 'LA FLORIDA', code: 93 },
  { name: 'LA GRANJA', code: 97 },
  { name: 'LA HIGUERA', code: 20 },
  { name: 'LA LIGUA', code: 59 },
  { name: 'LA PINTANA', code: 327 },
  { name: 'LA REINA', code: 92 },
  { name: 'LA SERENA', code: 19 },
  { name: 'LA UNION', code: 251 },
  { name: 'LAGO RANCO', code: 254 },
  { name: 'LAGO VERDE', code: 312 },
  { name: 'LAGUNA BLANCA', code: 316 },
  { name: 'LAJA', code: 210 },
  { name: 'LAMPA', code: 78 },
  { name: 'LANCO', code: 249 },
  { name: 'LAS CABRAS', code: 116 },
  { name: 'LAS CONDES', code: 71 },
  { name: 'LAUTARO', code: 231 },
  { name: 'LEBU', code: 199 },
  { name: 'LICANTEN', code: 145 },
  { name: 'LIMACHE', code: 53 },
  { name: 'LINARES', code: 159 },
  { name: 'LITUECHE', code: 136 },
  { name: 'LLANQUIHUE', code: 267 },
  { name: 'LLAY LLAY', code: 65 },
  { name: 'LO BARNECHEA', code: 332 },
  { name: 'LO ESPEJO', code: 337 },
  { name: 'LO PRADO', code: 325 },
  { name: 'LOLOL', code: 129 },
  { name: 'LONCOCHE', code: 240 },
  { name: 'LONGAVI', code: 162 },
  { name: 'LONQUIMAY', code: 226 },
  { name: 'LOS ALAMOS', code: 200 },
  { name: 'LOS ANDES', code: 66 },
  { name: 'LOS ANGELES', code: 204 },
  { name: 'LOS LAGOS', code: 247 },
  { name: 'LOS MUERMOS', code: 264 },
  { name: 'LOS SAUCES', code: 218 },
  { name: 'LOS VILOS', code: 33 },
  { name: 'LOTA', code: 195 },
  { name: 'LUMACO', code: 223 },
  { name: 'MACHALI', code: 106 },
  { name: 'MACUL', code: 323 },
  { name: 'MAFIL', code: 246 },
  { name: 'MAIPU', code: 94 },
  { name: 'MALLOA', code: 122 },
  { name: 'MARCHIGUE', code: 134 },
  { name: 'MARIA ELENA', code: 298 },
  { name: 'MARIA PINTO', code: 90 },
  { name: 'MARIQUINA', code: 245 },
  { name: 'MAULE', code: 154 },
  { name: 'MAULLIN', code: 263 },
  { name: 'MEJILLONES', code: 8 },
  { name: 'MELIPEUCO', code: 304 },
  { name: 'MELIPILLA', code: 88 },
  { name: 'MOLINA', code: 147 },
  { name: 'MONTE PATRIA', code: 26 },
  { name: 'MOSTAZAL', code: 111 },
  { name: 'MULCHEN', code: 214 },
  { name: 'NACIMIENTO', code: 212 },
  { name: 'NANCAGUA', code: 126 },
  { name: 'NATALES', code: 291 },
  { name: 'NAVIDAD', code: 138 },
  { name: 'NEGRETE', code: 213 },
  { name: 'NINHUE', code: 174 },
  { name: 'NOGALES', code: 52 },
  { name: 'NUEVA IMPERIAL', code: 234 },
  { name: 'ÑUÑOA', code: 91 },
  { name: 'O´HIGGINS', code: 310 },
  { name: 'OLIVAR', code: 120 },
  { name: 'OLLAGUE', code: 300 },
  { name: 'OLMUE', code: 54 },
  { name: 'OSORNO', code: 255 },
  { name: 'OVALLE', code: 25 },
  { name: 'PADRE HURTADO', code: 339 },
  { name: 'PADRE LAS CASAS', code: 349 },
  { name: 'PAIHUANO', code: 24 },
  { name: 'PAILLACO', code: 252 },
  { name: 'PAINE', code: 104 },
  { name: 'PALENA', code: 282 },
  { name: 'PALMILLA', code: 130 },
  { name: 'PANGUIPULLI', code: 250 },
  { name: 'PANQUEHUE', code: 62 },
  { name: 'PAPUDO', code: 57 },
  { name: 'PAREDONES', code: 133 },
  { name: 'PARRAL', code: 164 },
  { name: 'PEDRO AGUIRRE CERDA', code: 336 },
  { name: 'PELARCO', code: 152 },
  { name: 'PELLUHUE', code: 320 },
  { name: 'PEMUCO', code: 184 },
  { name: 'PEÑAFLOR', code: 85 },
  { name: 'PEÑALOLEN', code: 322 },
  { name: 'PENCAHUE', code: 153 },
  { name: 'PENCO', code: 191 },
  { name: 'PERALILLO', code: 131 },
  { name: 'PERQUENCO', code: 233 },
  { name: 'PETORCA', code: 55 },
  { name: 'PEUMO', code: 115 },
  { name: 'PICA', code: 4 },
  { name: 'PICHIDEGUA', code: 118 },
  { name: 'PICHILEMU', code: 137 },
  { name: 'PINTO', code: 169 },
  { name: 'PIRQUE', code: 101 },
  { name: 'PITRUFQUEN', code: 237 },
  { name: 'PLACILLA', code: 127 },
  { name: 'PORTEZUELO', code: 171 },
  { name: 'PORVENIR', code: 292 },
  { name: 'POZO ALMONTE', code: 5 },
  { name: 'PRIMAVERA', code: 317 },
  { name: 'PROVIDENCIA', code: 72 },
  { name: 'PUCHUNCAVI', code: 36 },
  { name: 'PUCON', code: 242 },
  { name: 'PUDAHUEL', code: 82 },
  { name: 'PUENTE ALTO', code: 100 },
  { name: 'PUERTO MONTT', code: 261 },
  { name: 'PUERTO OCTAY', code: 258 },
  { name: 'PUERTO VARAS', code: 266 },
  { name: 'PUMANQUE', code: 135 },
  { name: 'PUNITAQUI', code: 27 },
  { name: 'PUNTA ARENAS', code: 290 },
  { name: 'PUQUELDON', code: 274 },
  { name: 'PUREN', code: 217 },
  { name: 'PURRANQUE', code: 260 },
  { name: 'PUTAENDO', code: 61 },
  { name: 'PUTRE', code: 294 },
  { name: 'PUYEHUE', code: 256 },
  { name: 'QUEILEN', code: 272 },
  { name: 'QUELLON', code: 273 },
  { name: 'QUEMCHI', code: 278 },
  { name: 'QUILACO', code: 215 },
  { name: 'QUILICURA', code: 79 },
  { name: 'QUILLECO', code: 206 },
  { name: 'QUILLON', code: 182 },
  { name: 'QUILLOTA', code: 48 },
  { name: 'QUILPUE', code: 38 },
  { name: 'QUINCHAO', code: 275 },
  { name: 'QUINTA DE TILCOCO', code: 123 },
  { name: 'QUINTA NORMAL', code: 81 },
  { name: 'QUINTERO', code: 35 },
  { name: 'QUIRIHUE', code: 172 },
  { name: 'RANCAGUA', code: 105 },
  { name: 'RANQUIL', code: 187 },
  { name: 'RAUCO', code: 143 },
  { name: 'RECOLETA', code: 329 },
  { name: 'RENAICO', code: 219 },
  { name: 'RENCA', code: 77 },
  { name: 'RENGO', code: 121 },
  { name: 'REQUINOA', code: 119 },
  { name: 'RETIRO', code: 165 },
  { name: 'RINCONADA', code: 68 },
  { name: 'RIO BUENO', code: 253 },
  { name: 'RIO CLARO', code: 149 },
  { name: 'RIO HURTADO', code: 28 },
  { name: 'RIO IBAÑEZ', code: 288 },
  { name: 'RIO NEGRO', code: 259 },
  { name: 'RIO VERDE', code: 314 },
  { name: 'ROMERAL', code: 141 },
  { name: 'SAAVEDRA', code: 236 },
  { name: 'SAGRADA FAMILIA', code: 148 },
  { name: 'SALAMANCA', code: 32 },
  { name: 'SAN ANTONIO', code: 42 },
  { name: 'SAN BERNARDO', code: 98 },
  { name: 'SAN CARLOS', code: 176 },
  { name: 'SAN CLEMENTE', code: 151 },
  { name: 'SAN ESTEBAN', code: 69 },
  { name: 'SAN FABIAN', code: 178 },
  { name: 'SAN FELIPE', code: 60 },
  { name: 'SAN FERNANDO', code: 124 },
  { name: 'SAN GREGORIO', code: 315 },
  { name: 'SAN IGNACIO', code: 181 },
  { name: 'SAN JAVIER', code: 156 },
  { name: 'SAN JOAQUIN', code: 335 },
  { name: 'SAN JOSE DE MAIPO', code: 102 },
  { name: 'SAN JUAN DE LA COSTA', code: 307 },
  { name: 'SAN MIGUEL', code: 95 },
  { name: 'SAN NICOLAS', code: 179 },
  { name: 'SAN PABLO', code: 257 },
  { name: 'SAN PEDRO', code: 108 },
  { name: 'SAN PEDRO DE ATACAMA', code: 301 },
  { name: 'SAN PEDRO DE LA PAZ', code: 343 },
  { name: 'SAN RAFAEL', code: 351 },
  { name: 'SAN RAMON', code: 326 },
  { name: 'SAN ROSENDO', code: 211 },
  { name: 'SAN VICENTE', code: 117 },
  { name: 'SANTA BARBARA', code: 205 },
  { name: 'SANTA CRUZ', code: 128 },
  { name: 'SANTA JUANA', code: 196 },
  { name: 'SANTA MARIA', code: 64 },
  { name: 'SANTIAGO', code: 70 },
  { name: 'SANTO DOMINGO', code: 43 },
  { name: 'SIERRA GORDA', code: 299 },
  { name: 'SIN INFORMACION', code: 352 },
  { name: 'TALAGANTE', code: 86 },
  { name: 'TALCA', code: 150 },
  { name: 'TALCAHUANO', code: 189 },
  { name: 'TALTAL', code: 9 },
  { name: 'TEMUCO', code: 227 },
  { name: 'TENO', code: 142 },
  { name: 'TEODORO SCHMIDT', code: 306 },
  { name: 'TIERRA AMARILLA', code: 15 },
  { name: 'TIL-TIL', code: 80 },
  { name: 'TIMAUKEL', code: 318 },
  { name: 'TIRUA', code: 203 },
  { name: 'TOCOPILLA', code: 6 },
  { name: 'TOLTEN', code: 239 },
  { name: 'TOME', code: 190 },
  { name: 'TORRES DEL PAINE', code: 313 },
  { name: 'TORTEL', code: 311 },
  { name: 'TRAIGUEN', code: 222 },
  { name: 'TREHUACO', code: 173 },
  { name: 'TUCAPEL', code: 209 },
  { name: 'VALDIVIA', code: 243 },
  { name: 'VALLENAR', code: 16 },
  { name: 'VALPARAISO', code: 34 },
  { name: 'VICHUQUEN', code: 146 },
  { name: 'VICTORIA', code: 224 },
  { name: 'VICUÑA', code: 23 },
  { name: 'VILCUN', code: 228 },
  { name: 'VILLA ALEGRE', code: 163 },
  { name: 'VILLA ALEMANA', code: 39 },
  { name: 'VILLARRICA', code: 241 },
  { name: 'VIÑA DEL MAR', code: 37 },
  { name: 'VITACURA', code: 331 },
  { name: 'YERBAS BUENAS', code: 160 },
  { name: 'YUMBEL', code: 207 },
  { name: 'YUNGAY', code: 183 },
  { name: 'ZAPALLAR', code: 58 },
];

export default {
  zurichCommunes,
  bciCommunes,
  hdiCommunes,
};
